import AnnouncementIcon from "@mui/icons-material/Announcement";
import { Box, BoxProps, FormHelperText, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FieldMetaProps } from "formik";

export interface IFieldError {
  meta: Partial<FieldMetaProps<any>>;
  icon?: boolean;
}

const ErrorBox = styled((props: BoxProps) => <Box {...props} />)(({ theme }) => ({
  backgroundColor: theme.palette.error.dark,
  border: `1px solid ${theme.palette.error.main}`,
  color: theme.palette.common.white,
  padding: "2px",
  margin: "0px 5px",
  lineHeight: 0.65,
  cursor: "help",
  "& svg": {
    transform: "scaleX(-1)",
  },
}));

const ErrorTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  position: "relative",
  zIndex: 4000,
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.error.dark,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `${theme.palette.error.dark} !important`,
  },
}));

export const FieldError = (props: IFieldError): JSX.Element => {
  const { meta, icon } = props;
  return meta?.hasOwnProperty("error") && typeof meta?.error === "string" && meta?.error !== "" ? (
    <>
      {icon ? (
        <ErrorBox>
          <ErrorTooltip title={meta.error} arrow placement="left-start">
            <AnnouncementIcon fontSize="small" />
          </ErrorTooltip>
        </ErrorBox>
      ) : (
        <FormHelperText classes={{ root: "error-message" }}>
          <AnnouncementIcon fontSize="small" sx={{ marginRight: 2 }} />
          {meta.error}
        </FormHelperText>
      )}
    </>
  ) : null;
};
